import $ from './jquery-shim.js';

var defaultOptions = {
  containerClass: '.c-news-renewal__container',
  tabClass: '.c-news-renewal__tab',
  tabItemClass: '.c-news-renewal__tab-item',
  contentClass: '.c-news-renewal__content',
};

export default class NewsTab {
  constructor(options) {
    this.options = $.extend(options, defaultOptions);
    this.init();
  }

  init(){
    this.onClick();
  }

  onClick(){
    let self = this;
    $(document).on('click', this.options.tabItemClass + ' span', function () {
      let index = $(this).parent().index();
      // タブ
      $(self.options.tabItemClass).removeClass('is-active');
      $(self.options.tabClass + ' ' + self.options.tabItemClass).eq(index).addClass('is-active');

      // コンテンツ
      $(self.options.contentClass).removeClass('is-active');
      $(self.options.contentClass).hide();
      $(self.options.containerClass + ' ' + self.options.contentClass).eq(index).addClass('is-active');
      $(self.options.containerClass + ' ' + self.options.contentClass).eq(index).fadeIn();
    });
  }
}
